import {
  CleanValuesOptions,
  compileValidationSchema,
  makePropertyCleaner,
  schemaProperties,
} from '@pogokid/schema'
import { ContactSchema } from '../../.types/Contact.schema'
import contactSchema from '../../.types/Contact.schema.json'
import { compileJsonSchema } from '@pogokid/schema/dynamic'

export const contactCleanValues: CleanValuesOptions = {
  // Only clean meta if there are values
  shouldCleanProperties(property, value) {
    return property !== 'meta' || Object.keys(value).length > 0
  },
}

export const validateContact =
  compileValidationSchema<ContactSchema>(
    'ContactSchema',
    compileJsonSchema(contactSchema.definitions.ContactSchema),
    contactCleanValues
  )
export const contactProperties = schemaProperties(
  contactSchema.definitions.ContactSchema
)
export const cleanContactProperties =
  makePropertyCleaner<ContactSchema>(contactProperties)
